import { render } from "./ChromosomePage.vue?vue&type=template&id=350e4052&scoped=true"
import script from "./ChromosomePage.vue?vue&type=script&lang=js"
export * from "./ChromosomePage.vue?vue&type=script&lang=js"

import "./ChromosomePage.vue?vue&type=style&index=0&id=350e4052&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350e4052"]])

export default __exports__